import styled from 'styled-components'

const Currency = styled.span`
  position: absolute;
  left: 16px;
  top: 14px;
`

const TextFieldWrapper = styled.div`
  position: relative;
  height: 50px;
  overflow: hidden;
  border-radius: 3px;
`

const TextFieldLabel = styled.label`
  position: absolute;
  font-size: 12px;
  bottom: 0;
  left: 40px;
  width: 100%;
  height: 100%;
  pointer-events: none;
  color: #989898;
  border-bottom: 1px solid
    ${props => (props.isError ? '#f80505' : '#d8d8d8')};

  &::after {
    content: '';
    position: absolute;
    left: 0;
    bottom: -1px;
    height: 100%;
    width: 100%;
    transform: translateX(-100%);
    transition: transform 0.3s ease;
  }
`

const TextFieldSpan = styled.span`
  position: absolute;
  bottom: 5px;
  left: 0;
  transition: all 0.3s ease;
`

const TextFieldInput = styled.input`
   border: none;
    background-color: #F2F2F5;
    border-radius: 4px;
    width: 100%;
    font-size: 16px;
    line-height: 21px;
    padding: 15px;
    color: #3A3A3A;
    font-family: inherit;
    font-weight: 300;
    height: 50px;
    text-align: right;
    &:focus {
      outline: none;
    }

  &[disabled] {
    cursor: not-allowed;
    opacity: 0.4;
    background: rgba(0,0,0,0.3);
  }

  &[readOnly] {
    opacity: 0.4;
    background: rgba(0,0,0,0.3);
  }

  &[type='password'] {
    font-size: 1em;
  }

  &[type='number'] {
    -moz-appearance: textfield;
  }

  &[type='number']::-webkit-inner-spin-button,
  &[type='number']::-webkit-outer-spin-button {
    margin: 0;
    -webkit-appearance: none;
  }

  & + input {
    border-top-left-radius: 0;
    border-bottom-left-radius: 0;
  }

  &:focus
    + ${TextFieldLabel}
    ${TextFieldSpan},
    &:valid
    + ${TextFieldLabel}
    ${TextFieldSpan} {
    transform: translateY(-100%);
    margin-bottom: 10px;

    left: -30px;
  }

  &:focus + ${TextFieldLabel}::after, &:valid + ${TextFieldLabel}::after {
    transform: translateX(0%);

    ${TextFieldLabel} {
      border-bottom: none;
    }
  }
`

const LabelInputError = styled.span`
  font-size: 12px;
  color: #f80505;
  margin: 5px 0 0 0;
  display: flex;
`

export {
  Currency,
  TextFieldWrapper,
  TextFieldLabel,
  TextFieldSpan,
  TextFieldInput,
  LabelInputError,
}
